module.exports = __webpack_public_path__ + "static/media/recipe_category_4.f67a3596.png";